import { createAction } from '@reduxjs/toolkit';

const COMPOSITE_COMMANDS_NAMESPACE = 'sheetsManager/history';

interface StartCreateNewSheet {
  // template : string
  groupId?: string;
  windowId?: string;
}

export const startCreateNewSheet = createAction<StartCreateNewSheet>(
  `${COMPOSITE_COMMANDS_NAMESPACE}/startCreateSheet`
);
